// AdSense Client ID - This is a public publisher ID, safe to expose in client-side code
// However, we use environment variable for flexibility
export const ADSENSE_CLIENT_ID = process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-1942157564046703';

export const ADSENSE_SLOTS = {
  HOME_BANNER: '1182413283',
  SEARCH_SIDEBAR: '1182413283',
  CONTENT_DETAIL_SIDEBAR: '1182413283',
  CONTENT_LIST_BANNER: '1182413283',
} as const;

